/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TransactionsPaginated } from './TransactionsPaginated';
import {
    TransactionsPaginatedFromJSON,
    TransactionsPaginatedFromJSONTyped,
    TransactionsPaginatedToJSON,
    TransactionsPaginatedToJSONTyped,
} from './TransactionsPaginated';

/**
 * 
 * @export
 * @interface GetTransactionsPaginatedResponse
 */
export interface GetTransactionsPaginatedResponse {
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsPaginatedResponse
     */
    balance: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsPaginatedResponse
     */
    fuelPricePerUsd?: number;
    /**
     * 
     * @type {number}
     * @memberof GetTransactionsPaginatedResponse
     */
    balanceInUsd?: number;
    /**
     * 
     * @type {TransactionsPaginated}
     * @memberof GetTransactionsPaginatedResponse
     */
    transactions: TransactionsPaginated;
}

/**
 * Check if a given object implements the GetTransactionsPaginatedResponse interface.
 */
export function instanceOfGetTransactionsPaginatedResponse(value: object): value is GetTransactionsPaginatedResponse {
    if (!('balance' in value) || value['balance'] === undefined) return false;
    if (!('transactions' in value) || value['transactions'] === undefined) return false;
    return true;
}

export function GetTransactionsPaginatedResponseFromJSON(json: any): GetTransactionsPaginatedResponse {
    return GetTransactionsPaginatedResponseFromJSONTyped(json, false);
}

export function GetTransactionsPaginatedResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTransactionsPaginatedResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'],
        'fuelPricePerUsd': json['fuelPricePerUsd'] == null ? undefined : json['fuelPricePerUsd'],
        'balanceInUsd': json['balanceInUsd'] == null ? undefined : json['balanceInUsd'],
        'transactions': TransactionsPaginatedFromJSON(json['transactions']),
    };
}

export function GetTransactionsPaginatedResponseToJSON(json: any): GetTransactionsPaginatedResponse {
    return GetTransactionsPaginatedResponseToJSONTyped(json, false);
}

export function GetTransactionsPaginatedResponseToJSONTyped(value?: GetTransactionsPaginatedResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': value['balance'],
        'fuelPricePerUsd': value['fuelPricePerUsd'],
        'balanceInUsd': value['balanceInUsd'],
        'transactions': TransactionsPaginatedToJSON(value['transactions']),
    };
}

